import { useContext, useState } from "react";
import { Response } from "../../domain/app/Response";
import { PatrolRepository } from "../../data/repository/PatrolRepository";
import { UserPatrol } from "../../domain/patrol/Patrol";
import { AppTimestamp } from "../../domain/app/Timestamp";
import { UserAuthContext } from "../../ui/context/UserContext";
import { LocalErrorLogRepository } from "../../data/repository/LocalErrorLogRepository";
import { generateExcel } from "../../util/generateExcel";

type FormModalValues = {
  [key: string]: any;
};

export function useByRequestPatrolGroupViewModel() {
  const [fetchState, setFetchState] = useState<Response<boolean> | null>(null);
  const [userPatrolList, setUserPatrolList] = useState<
    UserPatrol[] | undefined
  >();
  const [userPatrolTimestamp, setUserPatrolTimestamp] = useState<
    AppTimestamp | undefined
  >();
  const [refreshEvent, setRefreshEvent] = useState<boolean | null>(null);
  const [selectedItem, setSelectedItem] = useState<UserPatrol | null>(null);
  const { appUser } = useContext(UserAuthContext);

  // search
  const [searchEvent, setSearchEvent] = useState<boolean | null>(null);
  const [searchState, setSearchState] = useState<Response<boolean> | null>(
    null
  );
  const [searchResults, setSearchResults] = useState<UserPatrol[] | null>(null);

  // generate excel
  const [generateEvent, setGenerateEvent] = useState<boolean | null>(null);

  const [generateState, setGenerateState] = useState<Response<boolean> | null>(
    null
  );

  // modal alert
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [descriptionAlert, setDescriptionAlert] = useState("");

  async function fetchUserPatrolList(
    timestamp: number,
    forceRefresh: boolean = false
  ) {
    if (fetchState?.isLoading()) return;
    setFetchState(Response.loading());
    try {
      const result = await PatrolRepository.getGlobal(
        timestamp,
        forceRefresh,
        appUser
      );
      console.log("userPatrolList", result);

      setUserPatrolList(result?.patrolList);
      setUserPatrolTimestamp(result?.timestamp);
      setFetchState(Response.success(true));
    } catch (e: any) {
      setFetchState(Response.failure(e));
    }
  }

  async function searchPatrol(values: FormModalValues) {
    setFetchState(Response.loading());
    try {
      const results = await PatrolRepository.searchPatrol(
        values.filter,
        values.search,
        values.searchInAll === true ? null : values.dpInicio.getTime(),
        values.searchInAll === true ? null : values.dpFinal.getTime(),
        values.searchInAll
      );

      console.log("results", results);
      setSearchResults(results || []);
      setFetchState(Response.success(true));
    } catch (e: any) {
      const label = `Error al buscar ronda: '${values.search}'`;
      await LocalErrorLogRepository.registerError(label, e);
      setFetchState(Response.failure(new Error(label)));
    }
  }

  async function toGenerateExcel() {
    setFetchState(Response.loading());
    try {
      console.log("to generate excel");
      console.log("search results", searchResults);
      if (searchResults?.length !== undefined && searchResults?.length > 0) {
        generateExcel(searchResults, "UserPatrol");
      } else {
        setIsAlertVisible(true);
        setDescriptionAlert(
          "Se necesita obtener resultados para generar Excel"
        );
      }

      setFetchState(Response.success(true));
    } catch (e: any) {
      const label = `Error al generar excel: ''`;
      await LocalErrorLogRepository.registerError(label, e);
      setFetchState(Response.failure(new Error(label)));
    }
  }

  function onFetchStateReceived() {
    setFetchState(null);
  }

  function requestRefreshEvent() {
    setRefreshEvent(true);
  }

  function onRefreshEventCompleted() {
    setRefreshEvent(null);
  }

  function requestSelectItem(item: UserPatrol) {
    setSelectedItem(item);
  }

  function onSelectItemCompleted() {
    setSelectedItem(null);
  }

  function requestSearchEvent() {
    setSearchEvent(true);
  }

  function onSearchEventCompleted() {
    setSearchEvent(null);
    setSearchResults(null);
  }

  function requestGenerateEvent() {
    setGenerateEvent(true);
  }

  function onGenerateEventCompleted() {
    setGenerateEvent(null);
  }

  return {
    //fetch
    fetchState,
    userPatrolList,
    userPatrolTimestamp,
    onFetchStateReceived,
    fetchUserPatrolList,
    //refresh
    refreshEvent,
    requestRefreshEvent,
    onRefreshEventCompleted,

    //search
    searchEvent,
    searchState,
    searchResults,
    requestSearchEvent,
    onSearchEventCompleted,
    searchPatrol,

    //generate excel
    generateEvent,
    generateState,
    requestGenerateEvent,
    onGenerateEventCompleted,
    toGenerateExcel,

    //alert
    isAlertVisible,
    setIsAlertVisible,
    descriptionAlert,

    //actions
    requestSelectItem,
    onSelectItemCompleted,
    selectedItem,
  };
}
